import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Channel Pages module configurations
export const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    width: '15%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'externalLink',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'version',
    label: 'Package Version',
    width: '15%',
    align: 'center',
    dataKey: 'version',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'assignChannel',
    label: 'Assign Channels Count',
    width: '5%',
    align: 'center',
    dataKey: 'assignChannel',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const ROKU_LISTING_ACTIONS = [
  {
    action: ACTIONS.ASSIGN_CHANNELS.value,
    label: ACTIONS.ASSIGN_CHANNELS.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.HTML,
  },
  {
    id: 'slug',
    label: 'Slug',
    dataKey: 'slug',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'showInFooter',
    label: 'Show In Footer',
    dataKey: 'showInFooter',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'showInHeader',
    label: 'Show In Header',
    dataKey: 'showInHeader',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'externalLink',
    label: 'External Link',
    dataKey: 'externalLink',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'header',
    label: 'Header',
    dataKey: 'header',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'meta',
    label: 'Meta',
    dataKey: 'meta',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'pageOrder',
    label: 'Order',
    dataKey: 'pageOrder',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
